import axios from "axios";

export const getLiveStormEvents = async () => {
  const response = await axios.get("/livestorm/events");

  return response.data;
};
